import { render, staticRenderFns } from "./ColourPalette.vue?vue&type=template&id=c55ef874&scoped=true&"
import script from "./ColourPalette.vue?vue&type=script&lang=js&"
export * from "./ColourPalette.vue?vue&type=script&lang=js&"
import style0 from "./ColourPalette.vue?vue&type=style&index=0&id=c55ef874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55ef874",
  null
  
)

export default component.exports